import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AppRoutes, RouteParams } from "./constants";
import { AuthGuard } from "./guards/auth/auth.guard";
import { CheckProgramGuard } from "./guards/check-program/check-program.guard";

const routes: Routes = [
  // CNG-19510 POC — isolated, unguarded canvas-library spike (throwaway). Kept ahead of
  // the guarded root so /poc/canvas is reachable without a program context.
  {
    path: "poc/canvas",
    loadChildren: () => import("./poc/canvas/poc-canvas.routes").then(r => r.POC_CANVAS_ROUTES),
  },
  {
    path: AppRoutes.root,
    canActivate: [CheckProgramGuard],
    children: [
      {
        path: AppRoutes.notFound,
        loadComponent: () => import("./pages/not-found/not-found.component").then(m => m.NotFoundComponent),
      },
      {
        path: `:${RouteParams.programId}`,
        children: [
          {
            path: AppRoutes.login,
            loadComponent: () => import("./pages/login/login.component").then(m => m.LoginComponent),
          },
          {
            path: "",
            canActivate: [AuthGuard],
            loadChildren: () => import("./pages/side-menu/side-menu.routes").then(r => r.SIDE_MENU_ROUTES),
          },
        ],
      },
      {
        path: "**",
        redirectTo: AppRoutes.notFound,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: "top" })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
